import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesome } from '../FontAwesome';
import './IconTooltip.scss';

// TODO: improve accessibility for this component
export class IconTooltip extends React.Component {
  static propTypes = {
    placement: PropTypes.oneOf(['right', 'top', 'left', 'bottom']),
    tooltip: PropTypes.string.isRequired,
    icon: PropTypes.string,
    id: PropTypes.string,
    trigger: PropTypes.arrayOf(PropTypes.string),
  };

  static defaultProps = {
    icon: 'info-circle',
    placement: 'right',
    id: 'tooltip', // TODO: this is not unique
    trigger: ['hover', 'focus'],
  };

  renderTooltip = () => {
    const { tooltip, id } = this.props;
    return <Tooltip {...{ id }}>{tooltip}</Tooltip>;
  };

  render() {
    const { placement, icon, trigger } = this.props;

    return (
      <icon-tooltip>
        <OverlayTrigger
          {...{ placement, trigger }}
          overlay={this.renderTooltip()}
        >
          <FontAwesome name={icon} className="trigger-tooltip-icon" />
        </OverlayTrigger>
      </icon-tooltip>
    );
  }
}
